import { Image } from '@chakra-ui/react'
import { cn } from 'components/common/utils/tailwindUtils'
import { ICard } from 'types/card.module'

const MerchantCard: React.FC<{
  cardConfig: ICard
  cardClassName?: string
  className?: string
  onClick: () => void
}> = ({ cardConfig, cardClassName, className, onClick }) => {
  return (
    <div className={cn('flex w-20 min-w-20 flex-col gap-2 p-[8px] md:w-26 md:min-w-26', className)}>
      {cardConfig.logo && (
        <Image
          draggable={false}
          src={cardConfig.logo}
          className={cn(
            `aspect-square w-full overflow-hidden rounded-2xl object-contain p-2 md:rounded-3xl
            xl:hover:cursor-pointer`,
            cardClassName,
          )}
          onClick={onClick}
          style={{
            background: cardConfig.primaryColor,

            border: `2px solid ${cardConfig.secondaryColor}`,
          }}
        />
      )}
      <div className='line-clamp-2 w-full text-mxs font-medium md:text-csm'>{cardConfig.name}</div>
    </div>
  )
}
export default MerchantCard
